<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="laborManagement-main"
  >
    <div class="constructionSite_content flex">
      <div class="content_left flexColumn">
        <!-- 今日考勤 -->
        <div class="content_style" style="height: 35%">
          <div class="style_title">最近考勤</div>
          <div class="style_content">
            <div style="margin-left: 30px; color: rgb(118, 223, 241)">
              <div>
                总人数：<span style="font-size: 20px">{{
                  LwInfo.todayKQ.totalWorker ? LwInfo.todayKQ.totalWorker : "456"
                }}</span
                >人
              </div>
            </div>
            <div class="flex attendance">
              <div class="attendanceImg">
                <div style="margin-top: 8px">
                  <span
                    >已出勤：{{
                      LwInfo.todayKQ.totalWorker
                        ? LwInfo.todayKQ.totalWorker == 0
                          ? 0
                          : (
                              (LwInfo.todayKQ.attendanceNum /
                                LwInfo.todayKQ.totalWorker) *
                              100
                            ).toFixed(2)
                        : "75.00"
                    }}%</span
                  >
                </div>
              </div>
              <div class="attendanceImg">
                <div style="margin-top: 8px">
                  <span
                    >未出勤：{{
                      LwInfo.todayKQ.totalWorker
                        ? LwInfo.todayKQ.totalWorker == 0
                          ? 0
                          : (
                              (LwInfo.todayKQ.NoAttendanceNum /
                                LwInfo.todayKQ.totalWorker) *
                              100
                            ).toFixed(2)
                        : "25.00"
                    }}%</span
                  >
                </div>
              </div>
            </div>
            <div class="flex todayAttendanceTU" style="height: 88%">
              <div
                id="todayAttendance"
                style="width: 380px; height: 200px"
              ></div>
            </div>
          </div>
        </div>
        <!-- 年龄分布 -->
        <div class="content_style" style="height: 35%">
          <div class="style_title">年龄分布</div>
          <div class="style_content">
            <div style="width: 100%; height: 100%" id="Agedistribution"></div>
          </div>
        </div>
        <!-- VR安全教育 -->
        <div class="content_style" style="height: 30%">
          <div class="style_title">VR安全教育</div>
          <div class="style_content">
            <div class="swiper" ref="swiper">
              <el-carousel
                style="width: 100%; height: 100%"
                trigger="click"
                arrow="always"
                indicator-position="none"
              >
                <el-carousel-item v-for="(item, index) in backimg" :key="index">
                  <img
                    v-if="item.img"
                    :src="item.img"
                    style="width: 100%; height: 100%"
                  />
                  <v-chart
                    ref="runTimeChart"
                    v-else
                    theme="macarons"
                    style="height: 100%; width: 100%; display: inline-block"
                    :options="todayOption"
                  ></v-chart>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <div class="content_center">
        <!-- 最新考勤动态 -->
        <div class="content_style" style="height: 55%">
          <div class="style_title2">最新考勤动态</div>
          <div class="style_content" style="overflow-y: scroll">
            <div
              class="flex"
              style="
                flex-wrap: wrap;
                align-items: stretch;
                margin: -10px 0px 0px -15px;
                display: -webkit-box;
              "
            >
              <div
                style="margin: 20px 0px 0px 20px"
                v-for="(item, index) in newAttendance"
                :key="index"
              >
                <img
                  :src="item.img"
                  alt=""
                  width="111"
                  height="105"
                  style="display: block"
                />
                <div class="newAttendance">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 人员变动 -->
        <div class="content_style" style="height: 45%">
          <div class="style_title2">人员变动</div>
          <div class="style_content">
            <div
              style="width: 100%; height: 100%"
              id="uploadAndownLoadMonth"
            ></div>
          </div>
        </div>
      </div>
      <div class="content_right flexColumn">
        <!-- 籍贯分布 -->
        <div class="content_style" style="height: 38%">
          <div class="style_title">籍贯分布</div>
          <div class="style_content">
            <div
              style="width: 100%; height: 100%"
              id="Nativeplacedistribution"
            ></div>
          </div>
        </div>
        <!-- 工种分布 -->
        <div class="content_style" style="height: 62%">
          <div class="style_title">工种分布</div>
          <div class="style_content">
            <div style="width: 100%; height: 100%" id="JobDistribution"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Getgdlabour } from "@/setAxios.js";
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import * as echarts from "echarts";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);

import { GetLwInfo, GetProjectInfo } from "@/setAxios";
export default {
  name: "laborManagement",
  components: {},
  data() {
    return {
      newAttendance: [
        {
          name: "李思霖",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/01.jpg"),
        },
        {
          name: "郑雅婷",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/02.jpg"),
        },
        {
          name: "钱博文",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/03.jpg"),
        },
        {
          name: "吴思怡",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/04.jpg"),
        },
        {
          name: "赵晓辉",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/05.jpg"),
        },
        {
          name: "吴宦颉",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/06.jpg"),
        },
        {
          name: "王帼玮",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/07.jpg"),
        },
        {
          name: "李辉煌",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/08.jpg"),
        },
        {
          name: "何兵",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/09.jpg"),
        },
        {
          name: "王子凡",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/10.jpg"),
        },
        {
          name: "冯宇",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/11.jpg"),
        },
        {
          name: "吴彦瑾",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/12.jpg"),
        },
        {
          name: "赵山川",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/13.jpg"),
        },
        {
          name: "王嘉沃",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/14.jpg"),
        },
        {
          name: "何林贤",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/15.jpg"),
        },
        {
          name: "何宇",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/16.jpg"),
        },
        {
          name: "周晟",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/17.jpg"),
        },
        {
          name: "赵容",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/18.jpg"),
        },
        {
          name: "赵丽义",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/19.jpg"),
        },
        {
          name: "赵晓燕",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/20.jpg"),
        },
        {
          name: "何颖奇",
          img: require("../../../assets/img/Wisdom/劳务管理-照片/21.jpg"),
        },
      ],
      todayOption: {},
      dataList: [],
      backimg: [
        {},
        {
          img: require("../../../assets/img/Wisdom/13.00.34 未佩戴安全帽.png"),
        },
        {
          img: require("../../../assets/img/Wisdom/15.26.19 反光衣违规预警.png"),
        },
      ],

      //劳务管理
      projectCode: null,
      LwInfo: {
        todayKQ: {}, //今日考勤
        nlfb: [], //年龄分布
        kqdt: [], //考勤动态
        rybd: {}, //人员变动
        jgfb: [], //籍贯分布
        gzfb: [], //工种分布
      }, //劳务信息
      loading: false,
    };
  },
  mounted() {
    this.TodayAttendance();
    this.Agedistribution();
    this.uploadAndownLoadMonth();
    this.Nativeplacedistribution();
    this.JobDistribution();
    // 判断全屏了没有
    const that = this;
    window.onresize = () => {
      this.$refs.runTimeChart[0].resize();
    };
  },
  created() {
    this.todayEvent();
    this.init();
    this.GetProjectInfos();
  },
  methods: {
    //劳务管理 start ----------------------------------------------------------
    //获取项目信息
    async GetProjectInfos() {
      let res = await GetProjectInfo({ params: { id: this.$store.state.xid } });
      this.projectCode = res.Data.proj02;
      this.GetLwInfo();
    },
    async GetLwInfo() {
      this.loading = true;
      let res = await GetLwInfo({ code: this.projectCode });
      // let res = await GetLwInfo({ code: "2020050620231030" });
      this.loading = false;
      if (res.Data) {
        this.LwInfo = res.Data;
        if (this.LwInfo.todayKQ) {
          this.TodayAttendance(this.LwInfo.todayKQ);
        }
        if (this.LwInfo.nlfb.length) {
          this.Agedistribution(this.LwInfo.nlfb);
        }
        if (this.LwInfo.kqdt.length) {
          this.newAttendance = [];
          this.LwInfo.kqdt.forEach((v) => {
            this.newAttendance.push({
              name: v.name,
              img: v.val.includes("http")
                ? v.val
                : "data:image/png;base64," + v.val,
            });
          });
        }
        if (this.LwInfo.rybd.length) {
          this.uploadAndownLoadMonth(this.LwInfo.rybd);
        }
        if (this.LwInfo.jgfb.length) {
          this.Nativeplacedistribution(this.LwInfo.jgfb);
        }
        if (this.LwInfo.gzfb.length) {
          this.JobDistribution(this.LwInfo.gzfb);
        }
      }
    },
    //劳务管理 end ----------------------------------------------------------

    //给个初始宽高
    init() {
      this.$nextTick(() => {
        this.$refs.runTimeChart[0].resize();
      });
    },
    // vr安全教育
    async todayEvent() {
      let params = {
        xid: Number(localStorage.xid),
      };
      let res = await Getgdlabour({ params });

      if (res.Data.length) {
        res.Data.forEach((el) => {
          this.dataList.push({
            value: Number(el.gdlb04),
            name: el.gdlb03,
          });
        });
      } else {
        this.dataList = [
          { value: 50, name: "已完成" },
          { value: 49, name: "未完成" },
        ];
      }
      // debugger;
      let _this = this;
      this.todayOption = {
        color: ["#43A5FF", "#03F3F8"],
        legend: {
          bottom: "0",
          icon: "circle",
          textStyle: {
            color: "rgb(255,255,255,0.9)",
          },
        },
        tooltip: {
          trigger: "item",
        },
        toolbox: {
          show: true,
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["50%", "58%"],
            center: ["50%", "44%"],
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "outside",
                  // color: color[i],
                  formatter: function (params) {
                    var percent = 0;
                    var total = 0;
                    for (var i = 0; i < _this.dataList.length; i++) {
                      total += _this.dataList[i].value;
                    }
                    percent = ((params.value / total) * 100).toFixed(0);
                    if (params.name !== "") {
                      return "" + params.name + "" + percent + "%";
                    } else {
                      return "";
                    }
                  },
                },
                labelLine: {
                  length: 30,
                  length2: 10,
                  show: true,
                  color: "#00ffff",
                },
              },
            },
            labelLine: {
              length: 10,
            },
            tooltip: {
              show: false,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 15,
                fontWeight: "bold",
              },
            },
            data: (function () {
              let arr = [];
              let colorList = ["#43A5FF", "#03F3F8"];
              _this.dataList.forEach((el) => {
                arr.push({
                  value: el.value,
                  name: el.name,
                  itemStyle: {
                    normal: {
                      borderWidth: 5,
                      shadowBlur: 10,
                      // borderColor: "rgba(255,255,255,0.1)",
                      shadowColor: colorList[i],
                    },
                  },
                });
              });
              return arr;
            })(),
          },
          {
            name: "2",
            type: "pie",
            radius: ["40%", "43%"],
            center: ["50%", "44%"],
            avoidLabelOverlap: false,
            labelLine: {
              length: 20,
            },
            label: {
              show: false,
              position: "center",
            },
            tooltip: {
              show: false,
            },
            emphasis: {
              disable: false,
              scale: false, //扇区是否缩放
              scaleSize: 0,
              // label: {
              //   show: false,
              //   fontSize: 0,
              //   fontWeight: "bold",
              // },
            },
            itemStyle: {
              normal: {
                color: function (colors) {
                  var colorList = ["#D1BB09", "#D1BB09", "#D1BB09", "#D1BB09"];
                  return colorList[colors.dataIndex];
                },
                borderRadius: "50%",
                borderWidth: 10,
              },
            },
            data: [
              { value: 1, name: "" },
              { value: 1, name: "" },
              { value: 1, name: "" },
              { value: 1, name: "" },
            ],
          },
        ],
      };
    },
    TodayAttendance(todayKQ) {
      // 图表初始化函数
      var chart = Highcharts.chart("todayAttendance", {
        chart: {
          type: "pie", //指定图表的类型
          options3d: {
            enabled: true,
            alpha: 70, //X轴-3d偏转角度：倾斜角度
            beta: 0,
          },
          backgroundColor: "rgba(255,255,255,0)",
        },
        credits: { enabled: false }, //关闭官网链接标识
        title: {
          text: "", // 标题
        },
        legend: {
          // enabled: true, //不显示图例
          layout: "vertical", //图例布局：竖直方向排列
          backgroundColor: "rgba(255,255,255,0)", //图例背景颜色
          borderRadius: "5", //图例背景边框圆角
          maxHeight: 200, // 最大高度
          lineHeight: 200, // 行高
          padding: 0, //内边距
          itemMarginTop: 20, //图例每行举上高度
          squareSymbol: true,
          x: 0, //x,y设置图例位置
          y: 0,
          align: "right", //居左显示
          itemStyle: {
            //字体颜色
            color: "#fff",
          },
          verticalAlign: "middle", //图例框的垂直对齐
        },
        //显示的内容
        tooltip: {
          headerFormat: "{series.name}<br>",
          pointFormat: "{point.name}: <b>{point.percentage:.2f}%</b>", ///小数点保留位
        },
        /*
        在 3D 饼图中，chart.depth 对饼图是不起作用的，
        只有设置在 plotOptions.pie.depth 里的才有效
        */
        plotOptions: {
          pie: {
            innerSize: 0, //设置圆环
            allowPointSelect: true,
            cursor: "pointer",
            startAngle: 150, //图填充的开始角度
            slicedOffset: 20, // 突出间距
            size: 180, // 设置饼图大小
            depth: 20,
            dataLabels: {
              enabled: false, //去掉图例的数据标签
              formatter: function () {
                return (
                  '<p style="color:' +
                  this.color +
                  '">' +
                  this.point.name +
                  '</p><br><p style="color:' +
                  this.color +
                  '">' +
                  this.percentage.toFixed(2) +
                  "%</p>"
                );
              }, //图例数据颜色跟图例颜色一致
            },
            opacity: 1, //透明度
            colors: ["#00A8FF", "#00D7E9"],
            showInLegend: false, // 显示在图例中
          },
        }, // 针对特定图表类型生效的 3D 配置
        series: [
          {
            type: "pie",
            name: "",
            tooltip: {
              trigger: "item",
            },
            data: [
              {
                name: "已出勤",
                y: (function () {
                  if (todayKQ) {
                    return todayKQ.attendanceNum;
                  }
                  return 75;
                })(),
                sliced: true, // 突出显示某个扇区，表示强调
              },
              {
                name: "未出勤",
                y: (function () {
                  if (todayKQ) {
                    return todayKQ.NoAttendanceNum;
                  }
                  return 25;
                })(),
              },
            ],
          },
        ],
      });
    },
    Agedistribution(nlfb) {
      if (nlfb) {
        nlfb = nlfb.reverse();
      }
      var chartDom = document.getElementById("Agedistribution");
      var myChart = echarts.init(chartDom);
      var option;
      var data = [56, 92, 189, 119];
      var barWidth = 6;
      var maxNum = 0;
      if (nlfb) {
        nlfb.forEach((v) => {
          maxNum += Number(v.val);
        });
      } else {
        data.forEach((v) => {
          maxNum += v;
        });
      }
      option = {
        grid: {
          top: "2%",
          left: "2%",
          right: "-8%",
          bottom: "0%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (params) => {
            var res = `${params[0].name} <br/>`;
            for (const item of params) {
              if (item.seriesName !== "") {
                res += `<span style="background: rgb(15, 159, 252); height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.value}<br/>`;
              }
            }
            return res;
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          data: (function () {
            if (nlfb) {
              return nlfb.map((x) => x.name);
            }
            return ["50-65岁", "40-50岁", "30-40岁", "18-30岁"];
          })(),
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            inside: true,
            splitNumber: 50,
            boundaryGap: [20, 20],
            textStyle: {
              fontSize: "85%",
              color: "#fff",
              verticalAlign: "bottom",
              align: "left",
              padding: [0, 0, 10, -8],
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: false,
        },
        series: [
          {
            type: "bar",
            barWidth: barWidth,
            zlevel: 2,
            data: (function () {
              var data1 = [];
              if (nlfb) {
                nlfb.map(function (item) {
                  data1.push({
                    value: Number(item.val),
                    maxNum: maxNum,
                  });
                });
              } else {
                data.map(function (item) {
                  data1.push({
                    value: item,
                    maxNum: maxNum,
                  });
                });
              }
              return data1;
            })(),
            itemStyle: {
              barBorderRadius: [20, 20, 20, 20],
              color: new echarts.graphic.LinearGradient(0, 1, 1, 1, [
                { offset: 0, color: "rgb(33, 69, 185)" },
                { offset: 1, color: "rgb(64, 220, 220)" },
              ]),
            },
            barCategoryGap: "50%",
          },
          {
            type: "bar",
            barWidth: barWidth,
            barGap: "-100%",
            name: "",
            data: (function () {
              var data1 = [];
              if (nlfb) {
                nlfb.map(function (item) {
                  data1.push({
                    realValue: Number(item.val),
                    value: maxNum,
                  });
                });
              } else {
                data.map(function (item) {
                  data1.push({
                    realValue: item,
                    value: maxNum,
                  });
                });
              }
              return data1;
            })(),
            label: {
              inside: true,
              splitNumber: 50,
              boundaryGap: [20, 20],
              textStyle: {
                color: "#fff",
                verticalAlign: "bottom",
                align: "right",
                padding: [0, 50, 10, 0],
              },

              show: true,
              position: "right",
              distance: 40,
              align: "right",
              formatter: function (params) {
                return params.data.realValue + "名";
              },
              color: "#fff",
              fontSize: 12,
            },
            itemStyle: {
              color: "rgb(18, 57, 93)",
              barBorderRadius: [20, 20, 20, 20],
            },
            barCategoryGap: "50%",
          },
        ],
      };
      option && myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    uploadAndownLoadMonth(rybd) {
      if (rybd) {
        rybd = rybd.reverse();
      }
      var chartDom = document.getElementById("uploadAndownLoadMonth");
      var myChart = echarts.init(chartDom);
      var option;
      let lineData = [];
      if (rybd) {
        rybd.forEach((v) => {
          lineData.push(v.name);
        });
      } else {
        for (var i = 1; i <= 12; i++) {
          lineData.push(i + "月");
        }
      }
      option = {
        ///backgroundColor: "#0f375f",
        grid: {
          x: 55,
          y: 65,
          x2: 5,
          y2: 25,
          borderWidth: 1,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (params) => {
            var res = `${params[0].name} <br/>`;
            for (const item of params) {
              if (item.seriesName !== "") {
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} ：${item.value}<br/>`;
              }
            }
            return res;
          },
        },
        color: ["rgb(59, 204, 243)", "rgb(161, 130, 51)", "rgb(13, 143, 168)"],
        legend: {
          data: ["在职人数", "入职人数", "离职人数"],
          x: "right",
          textStyle: {
            color: "rgb(49, 166, 241)",
          },
        },
        xAxis: {
          data: lineData,
          axisLine: {
            lineStyle: {
              color: "rgb(47, 60, 80)",
            },
          },
          // 刻度
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgb(13, 114, 208)",
            },
          },
          // 刻度
          axisTick: {
            show: false,
          },
          //线轴 虚线
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              opacity: 0.2,
            },
          },
        },
        series: [
          {
            name: "在职人数",
            type: "bar",
            barWidth: 7,
            itemStyle: {
              borderRadius: 5,
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [55, 55, 55, 55],
              },
              color: new echarts.graphic.LinearGradient(0, 1, 1, 1, [
                { offset: 1, color: "rgb(59, 204, 243)" },
                { offset: 0, color: "rgb(34, 148, 241)" },
              ]),
            },
            data: (function () {
              if (rybd) return rybd.map((x) => x.val);
              return [
                155, 185, 255, 245, 395, 312, 375, 165, 266, 225, 226, 333,
              ];
            })(),
          },
          {
            name: "入职人数",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "none",
            symbolSize: 15,
            data: (function () {
              if (rybd) return rybd.map((x) => x.val1);
              return [
                125, 275, 155, 245, 195, 212, 175, 365, 266, 125, 315, 251,
              ];
            })(),
            lineStyle: {
              color: "rgb(161, 130, 51)",
            },
          },

          {
            name: "离职人数",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "none",
            symbolSize: 15,
            lineStyle: {
              color: "rgb(13, 143, 168)",
            },
            z: -12,
            data: (function () {
              if (rybd) return rybd.map((x) => x.val2);
              return [
                155, 185, 255, 245, 485, 412, 375, 165, 266, 225, 316, 123,
              ];
            })(),
          },
          {
            name: "",
            type: "bar",
            barGap: "-100%",
            barWidth: 8,
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [55, 55, 55, 55],
                color: "rgb(10, 34, 66)",
                borderColor: "rgb(20, 71, 101)",
              },
            },
            z: -12,
            data: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500],
          },
        ],
      };

      option && myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    Nativeplacedistribution(jgfb) {
      var chartDom = document.getElementById("Nativeplacedistribution");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          position: "buttom",
        },
        radar: {
          // shape: 'circle',
          splitNumber: 4, // 雷达图圈数设置
          // 设置雷达图中间射线的颜色
          name: {
            textStyle: {
              color: "#bbb",
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(131,141,158,.1)",
            },
          },
          indicator: (function () {
            if (jgfb) {
              var maxNum = 0,
                data1 = [];
              // jgfb.forEach((v) => {
              //   maxNum += Number(v.val);
              // });
              jgfb.forEach((v) => {
                if (Number(v.val) > maxNum) {
                  maxNum = Number(v.val);
                }
              });
              jgfb.forEach((v) => {
                data1.push({
                  name: v.name,
                  max: maxNum,
                });
              });
              return data1;
            }
            return [
              { name: "河北", max: 150 },
              { name: "其他", max: 150 },
              { name: "河南", max: 150 },
              { name: "江西", max: 150 },
              { name: "福建", max: 150 },
              { name: "安徽", max: 150 },
              { name: "辽宁", max: 150 },
              { name: "山西", max: 150 },
            ];
          })(),
          splitArea: {
            show: false,
            areaStyle: {
              color: "rgba(255,0,0,0)", // 图表背景的颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgb(18, 52, 98)", // 设置网格的颜色
            },
          },
        },
        series: [
          {
            name: "",
            type: "radar",
            tooltip: {
              trigger: "item",
            },
            data: [
              {
                value: (function () {
                  if (jgfb) {
                    var data1 = [];
                    jgfb.forEach((v) => {
                      data1.push(Number(v.val));
                    });
                    return data1;
                  }
                  return [75, 16, 70, 57, 55, 65, 42, 85];
                })(),
                name: "籍贯分布",
              },
            ],
            itemStyle: {
              normal: {
                color: "rgb(158, 239, 251)",
                lineStyle: {
                  color: "rgb(28, 172, 187)",
                },
              },
            },
            areaStyle: {
              // 单项区域填充样式
              normal: {
                color: "rgb(20, 102, 124)",
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    JobDistribution(gzfb) {
      var chartDom = document.getElementById("JobDistribution");
      var myChart = echarts.init(chartDom);
      var option;
      var data = [25, 75, 55, 45, 95, 12, 75, 65, 66, 25];
      var barWidth = 20;
      var maxNum = 0;
      if (gzfb) {
        gzfb.forEach((v) => {
          maxNum += Number(v.val);
        });
        data = gzfb.map((v) => Number(v.val));
      } else {
        data.forEach((v) => {
          maxNum += v;
        });
      }
      // debugger
      let scrollBar = false;

      let seriesData0 = drawTriangleSymbol(data);
      option = {
        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            left: "94%",
            start: 1,
            end: 50,
            startValue: 0, // 从头开始。
            endValue: 6, // 最多六个
            minValueSpan: 6, // 放大到最少几个
            maxValueSpan: 6, //  缩小到最多几个
            moveOnMouseMove: true,
            fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
            borderColor: "rgba(17, 100, 210, 0.12)",
            handleSize: 0, //两边手柄尺寸
            showDetail: false, //拖拽时是否展示滚动条两侧的文字
            zoomLock: false, //是否只平移不缩放
            zoomOnMouseWheel: false, //鼠标移动能触发数据窗口平移
          },
        ],
        grid: {
          top: "2%",
          left: "2%",
          right: "12%",
          bottom: "0%",
        },
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (params) => {
            var res = `${params[0].name} <br/>`;
            for (const item of params) {
              if (item.seriesName !== "") {
                res += `<span style="background: rgb(15, 159, 252); height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.value}<br/>`;
              }
            }
            return res;
          },
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          data: (function () {
            if (gzfb) return gzfb.map((v) => v.name);
            return [
              "油漆工",
              "木工",
              "养护工",
              "防水工",
              "门窗工",
              "钢筋工",
              "质检员",
              "管道工",
              "电焊工",
              "电工",
            ];
          })(),
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false, //关闭
            inside: true,
            splitNumber: 50,
            boundaryGap: [20, 20],
            textStyle: {
              fontSize: "80%",
              color: "#fff",
              verticalAlign: "bottom",
              align: "left",
              padding: [0, 0, 10, 332],
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: false,
        },
        series: [
          {
            type: "bar",
            barWidth: barWidth,
            zlevel: 2,
            data: (function () {
              var data1 = [];
              if (gzfb) {
                gzfb.map(function (item) {
                  data1.push({
                    value: Number(item.val),
                    maxNum: maxNum,
                  });
                });
              } else {
                data.map(function (item) {
                  data1.push({
                    value: item,
                    maxNum: maxNum,
                  });
                });
              }
              return data1;
            })(),
            itemStyle: {
              barBorderRadius: [20, 0, 0, 20],
              color: new echarts.graphic.LinearGradient(0, 1, 1, 1, [
                { offset: 0, color: "rgb(15, 159, 252)" },
                { offset: 1, color: "rgb(126, 216, 254)" },
              ]),
            },
            barCategoryGap: "50%",
            barWidth: "25%",
          },
          {
            type: "bar",
            barWidth: barWidth,
            barGap: "-100%",
            name: "",
            data: (function () {
              var data1 = [];
              if (gzfb) {
                gzfb.map(function (item) {
                  data1.push({
                    realValue: Number(item.val),
                    value: maxNum,
                  });
                });
              } else {
                data.map(function (item) {
                  data1.push({
                    realValue: item,
                    value: maxNum,
                  });
                });
              }
              return data1;
            })(),
            label: {
              show: true,
              position: "right",
              distance: 40,
              align: "right",
              formatter: function (params) {
                return (
                  params.name +
                  "\n\n" +
                  ((params.data.realValue / params.data.value) * 100).toFixed(
                    1
                  ) +
                  "%"
                );
              },
              color: "#fff",
              fontSize: 12,
            },
            itemStyle: {
              color: "rgb(18, 57, 93)",
              barBorderRadius: [20, 20, 20, 20],
            },
            barCategoryGap: "50%",
            barWidth: "25%",
          },
          // 小箭头
          {
            name: "",
            z: 6,
            type: "pictorialBar",
            data: seriesData0,
          },
        ],
      };
      option && myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      function drawTriangleSymbol(data) {
        // 绘制三角形
        let triangle = "path://M0 0 L2 0 L1 3 Z";
        let result = data.map((v) => ({
          value: v,
          symbol: `${triangle}`,
          itemStyle: {
            normal: {
              color: "rgb(78, 194, 254)",
            },
          },
          symbolPosition: "end", // 在数据结尾显示
          symbolSize: [10, 10], // 「大小」
          symbolOffset: [5, -15], //「偏移量」
        }));
        return result;
      }
    },
  },
};
</script>
<style lang="less">
.laborManagement-main {
  width: 100%;
  height: 100%;
  //   background-image: url("../../../assets/img/引导页.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  h1 {
    text-align: center;
    color: #fff;
    font-weight: bold;
    letter-spacing: 5px;
  }

  .constructionSite_content {
    margin-top: 0.3%;
    width: 100%;
    height: 100%;

    .content_left {
      width: 24%;
      height: 100%;
    }

    .content_right {
      width: 24%;
      height: 100%;
    }

    .content_center {
      margin-left: 1%;
      margin-right: 1%;
      width: 50%;
      height: 100%;
    }
  }

  .content_style {
    width: 100%;
    height: 33%;

    .style_title {
      background-image: url("../../../assets/img/Wisdom/Group 3.png");
      background-repeat: no-repeat;
      background-size: 100% 90%;
      font-size: 14px;
      padding: 8px 25px;
      font-weight: bold;
      color: #fff;
    }

    .style_title2 {
      background-image: url("../../../assets/img/Wisdom/Group23.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 14px;
      padding: 8px 20px;
      font-weight: bold;
      color: #fff;
    }

    .style_content {
      border-bottom: 2px solid #074b7c;
      height: calc(100% - 70px);
      margin-top: 10px;
      background-color: rgba(0, 0, 0, 0.5);
      width: calc(100% -20px);
      padding: 10px;
      color: #fff;
    }
  }

  .attendance {
    margin: 0px auto;
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
    width: 86%;

    .attendanceImg {
      color: rgb(118, 223, 241);
      font-size: 14px;
      background-image: url("../../../assets/img/Wisdom/attendance.png");
      width: 126px;
      height: 33px;
      text-align: center;
    }
  }

  .todayAttendanceTU {
    margin-top: -35px;
  }

  .todayAttendanceBJ {
    width: 280px;
    height: 105px;
    position: absolute;
    margin-top: 30px;
  }

  .sexStructure {
    width: 166px;
    height: 65px;
    background-image: url("../../../assets/img/Wisdom/Group 1985.png");
  }

  .newAttendance {
    width: 111px;
    height: 20px;
    background-image: url("../../../assets/img/Wisdom/Rectangle 704.png");
    margin-top: 5px;
    text-align: center;
    font-size: 14px;
    font-family: SYHT-Bold !important;
    font-weight: bold;
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .el-carousel__container {
    height: 100%;
  }
}
</style>
